import React from 'react';
import { Link } from 'react-router-dom';
import { FiLinkedin, FiFacebook, FiInstagram, FiArrowUp, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    { icon: <FiLinkedin />,  label: 'LinkedIn' },
    { icon: <FiFacebook />,  label: 'Facebook' },
    { icon: <FiInstagram />, label: 'Instagram' }
  ];

  const certifications = [
    { name: 'AWS Partner', abbr: 'AWS' },
    { name: 'Microsoft Partner', abbr: 'MSFT' },
    { name: 'ISO 27001', abbr: 'ISO' },
    { name: 'SOC 2 Certified', abbr: 'SOC2' },
    { name: 'AI Solutions Partner', abbr: 'AI' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-text">Sempersys<span className="logo-cursor">|.</span></span>
            </Link>
            <p className="footer-description">
              Transforming businesses through technology. We partner with organizations
              to deliver innovative solutions that drive growth and success.
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="social-link"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-contact">
            <h3 className="footer-title">Let's Connect</h3>
            <div className="contact-items">
              <a href="tel:+16476437182" className="contact-item">
                <FiPhone />
                <span>+1 (647) 643-7182</span>
              </a>
              <a href="mailto:support@sempersyscorp.com" className="contact-item">
                <FiMail />
                <span>support@sempersyscorp.com</span>
              </a>
              <div className="contact-item">
                <FiMapPin />
                <span>499 Main St S, Brampton, ON L6Y 1N7, Canada</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-certifications">
          <span className="cert-label">Trusted & Certified</span>
          <div className="cert-badges">
            {certifications.map((cert, index) => (
              <div key={index} className="cert-badge" title={cert.name}>
                <span className="cert-abbr">{cert.abbr}</span>
                <span className="cert-name">{cert.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            &copy; {new Date().getFullYear()} SemperSys Corp. All rights reserved.
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>
        </div>
      </div>

      <button className="scroll-top" onClick={scrollToTop} aria-label="Scroll to top">
        <FiArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
